<template>
    <div class="preloader-wrapper">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Preloader'
}
</script>

<style scoped lang="scss">
    .preloader-wrapper{
        z-index: 10;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.7);
    }
</style>
